import Vue from 'vue'

Vue.filter('floor', value => Math.floor(value))
